import CryptoJS from 'crypto-js';

const ENCRYPT_KEY = process.env.REACT_APP_ENCRYPT_KEY ;

export async function encryptCryptoJs(payload){

    const valorCriptografado = CryptoJS.AES.encrypt(payload, ENCRYPT_KEY).toString();
    return valorCriptografado;
}

export async function decryptCryptoJs(payload){

    const bytesDescriptografados = CryptoJS.AES.decrypt(payload, ENCRYPT_KEY);
    const valorDescriptografado = bytesDescriptografados.toString(CryptoJS.enc.Utf8);

    return valorDescriptografado;
}